module.exports = __webpack_public_path__ + "static/media/IMG_0115-2.7c8d168f.jpg";